import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    {/* Real paths rather than hash routes; a CloudFront function rewrites
        unknown paths to index.html (see lib/portal-site.ts). */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
